const R = 6371;

function haversine(lat1, lon1, lat2, lon2) {
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180) * Math.cos(lat2*Math.PI/180) * Math.sin(dLon/2)**2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

export function calculateOdometer(history) {
  const lats = (history.latitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const lons = (history.longitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  if (lats.length < 2 || lons.length < 2) return 0;
  let total = 0;
  for (let i = 1; i < Math.min(lats.length, lons.length); i++) {
    const d = haversine(lats[i-1].val, lons[i-1].val, lats[i].val, lons[i].val);
    if (d < 2) total += d;
  }
  return Math.round(total * 10) / 10;
}

export function getGPSTrack(history) {
  const lats = (history.latitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const lons = (history.longitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const points = [];
  for (let i = 0; i < Math.min(lats.length, lons.length); i++) {
    if (!isNaN(lats[i].val) && !isNaN(lons[i].val)) {
      points.push([lats[i].val, lons[i].val]);
    }
  }
  return points;
}

export function detectTrips(history) {
  const speeds = (history.speed || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const lats = (history.latitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const lons = (history.longitude || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);
  const fuel = (history.fuel_level_liters || []).map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) })).sort((a,b) => a.ts - b.ts);

  if (speeds.length < 3) return [];

  const trips = [];
  let inTrip = false;
  let tripStart = null;
  let tripPoints = [];
  let stopStreak = 0;

  for (let i = 0; i < speeds.length; i++) {
    const sp = speeds[i];
    if (sp.val > 5) {
      if (!inTrip) { inTrip = true; tripStart = sp.ts; tripPoints = []; stopStreak = 0; }
      const lat = lats.find(l => Math.abs(l.ts - sp.ts) < 90000);
      const lon = lons.find(l => Math.abs(l.ts - sp.ts) < 90000);
      if (lat && lon) tripPoints.push({ lat: lat.val, lon: lon.val });
      stopStreak = 0;
    } else if (inTrip) {
      stopStreak++;
      if (stopStreak >= 3) {
        let dist = 0;
        for (let j = 1; j < tripPoints.length; j++) dist += haversine(tripPoints[j-1].lat, tripPoints[j-1].lon, tripPoints[j].lat, tripPoints[j].lon);
        const duration = Math.round((sp.ts - tripStart) / 60000);
        const fStart = fuel.find(f => Math.abs(f.ts - tripStart) < 180000);
        const fEnd = fuel.find(f => Math.abs(f.ts - sp.ts) < 180000);
        const fuelUsed = fStart && fEnd ? Math.max(0, fStart.val - fEnd.val) : null;
        if (dist > 0.2 && duration > 1) {
          trips.push({
            start: tripStart, end: sp.ts, duration,
            distance: Math.round(dist * 10) / 10,
            fuelUsed: fuelUsed ? Math.round(fuelUsed * 10) / 10 : null,
            efficiency: fuelUsed && dist > 0.5 ? Math.round((fuelUsed / dist) * 1000) / 10 : null
          });
        }
        inTrip = false; tripStart = null; tripPoints = []; stopStreak = 0;
      }
    }
  }
  return trips;
}

export function getAverageEfficiency(trips) {
  const valid = trips.filter(t => t.efficiency && t.efficiency > 0 && t.efficiency < 60);
  if (!valid.length) return null;
  return Math.round(valid.reduce((s, t) => s + t.efficiency, 0) / valid.length * 10) / 10;
}
